export * from './page'
export * from './numbers'
export * from './basic_info'
export * from './manage_box'
export * from './donation_list'
export * from './description'
export * from './news'
export * from './controls'
export * from './forwardings'
export * from './sharing'
export * from './sticky'
export * from './donate_button'
export * from './donate_button_combo'

import '../shared/translation_setup'
// this file is auto-generated. to update it
// with content from the yml files,
// restart server or run `rake i18n:js:export`
export * from './translations'
